import { render } from "./UserStatistics.vue?vue&type=template&id=813113a4&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"

import "./UserStatistics.vue?vue&type=style&index=0&id=813113a4&scoped=true&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813113a4"]])

export default __exports__